import React, { useEffect, useState, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import '../Card/card-style.css';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import Cookies from 'js-cookie';
import { Auth } from 'aws-amplify';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';
import { LocationContext, LocationProvider } from '../../reducers/LocationContext';

function PracticeCard(props) {
    const {
        id,
        name,
        levels,
        specificcategory,
        limits,
        remainingattempts,
        totalquestions,
        eventdisplay,
        level,
        eventtype,
        category,
    } = props.event;

    const event_copy = props.event;
    const history = useHistory();

    const noofquestions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100];
    const [noofquestion, set_noofquestion] = useState();
    const [value, setValue] = useState([1, totalquestions]);
    const [random, setRandom] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const { subscriptionStatus } = useContext(SubscriptionContext); //  Use context
    const { countryCode } = useContext(LocationContext);

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(() => setIsAuthenticated(true))
            .catch(() => setIsAuthenticated(false));
    }, []);

    function setQuestionNo(questionnumber) {
        event_copy.start_limit = 0;
        event_copy.end_limit = questionnumber - 1;
        event_copy.randomize = random;
    }

    function randomme(change) {
        setRandom(prev => {
            const newVal = !prev;
            event_copy.randomize = newVal;
            return newVal;
        });
    }

    function handleChange(change) {
        setValue(change);
        event_copy.start_limit = change[0] - 1;
        event_copy.end_limit = change[1] - 1;
        event_copy.randomize = random;
    }


    const getPracticeLimitDetails = async (username, jwt) => {
        // console.log("Practice JWT:", jwt);
        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: jwt
                },
                body: JSON.stringify({ username }),
            };

            const response = await fetch(`https://api.quizwizard.net/quiz/trackpractice`, requestOptions);

            if (!response.ok) {
                // Handles HTTP status errors (e.g., 404, 500)
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.error) {
                console.error("Error in response data:", data.error);
                return false;
            }

            return data.allowed;

        } catch (error) {
            console.error("Error fetching practice limit details:", error.message || error);
            return false;
        }
    };


    const handlePracticeClick = async (e) => {
        e.preventDefault();
        let questionsPracticed = false;


        const user = await Auth.currentAuthenticatedUser();
        const res = await Auth.currentSession();
        const accessToken = res.getAccessToken();
        const getToken = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const session = await Auth.currentSession();
                const jwt = session.getIdToken().getJwtToken();
                return jwt;
            } catch (error) {
                //console.error("Auth error:", error); // Add this line for debugging
                await Auth.signOut();
                return null;
            }
        };

        const jwt = await getToken();

        if (user.username.includes("Google_")) {
            questionsPracticed = await getPracticeLimitDetails(user.attributes['email'], jwt);
        } else {
            questionsPracticed = await getPracticeLimitDetails(user.username, jwt);
        }


        //console.log("Questions Practiced:", questionsPracticed);

        if (questionsPracticed === "False" || questionsPracticed === false) {
            //console.log("User has practiced questions today, redirecting to practice quiz.");

            if (subscriptionStatus === 'none' && countryCode == 'IN') {
                history.push('/subscribe');
            }
            else if (subscriptionStatus === 'none') {
                history.push('/subscription');
            } else if (subscriptionStatus === 'expired') {
                history.push('/expired');
            } else if (subscriptionStatus === "active" || subscriptionStatus === 1 || subscriptionStatus === true) {
                history.push({
                    pathname: '/practicequiz',
                    state: event_copy,
                });
            }
            return;
        }




        history.push({
            pathname: '/practicequiz',
            state: event_copy,
        });
    };

    return (
        <div className="card text-center shadow">
            <div className="overflow">
                <Link to={{ pathname: '/practicequiz', state: event_copy }} onClick={handlePracticeClick}>
                    <img
                        src={'../assets/' + category + '.png'}
                        alt=""
                        className="card-img-top"
                        width="200"
                        height="250"
                    />
                </Link>
            </div>
            <div className="card-body text-dark">
                <h4 className="card-text">{name}</h4>

                {(["SpellBowl", "Spanish", "Invitational", "ScienceBowl"].includes(category)) && (
                    <>
                        <h5 className="card2-text">Shuffle</h5>
                        <div className="ct-input">
                            <label className="switch">
                                <input type="checkbox" onChange={randomme} defaultChecked={true} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </>
                )}

                {(totalquestions > 30 || category === "Spell-it") && (
                    <div className="ct-input-range">
                        <span className="ct-input-label">QNo:</span>
                        <div className="ct-input-val">
                            <span className="ct-input-val-1">{value[0]}</span>
                            <Slider
                                trackStyle={{ height: 10 }}
                                handleStyle={{ height: 20, width: 20 }}
                                railStyle={{ height: 10 }}
                                defaultValue={value}
                                range={[1, totalquestions]}
                                max={totalquestions}
                                min={1}
                                onChange={handleChange}
                            />
                            <span className="ct-input-val-2">{value[1]}</span>
                        </div>
                    </div>
                )}

                {(totalquestions < 30 && category !== "Spell-it") && (
                    <span className="custom-dropdown">
                        <select
                            name="noofquestion"
                            value={noofquestion}
                            placeholder="No of Questions"
                            onChange={e => setQuestionNo(e.target.value)}
                            required>
                            <option key="">No of Questions</option>
                            {noofquestions.filter(q => q <= totalquestions).map(q => (
                                <option key={q}>{q}</option>
                            ))}
                        </select>
                    </span>
                )}
            </div>
        </div>
    );
}

export default PracticeCard;
